var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-pie-chart"},[_c('div',{staticClass:"report-pie-chart-wrapper"},[_c('div',{staticClass:"report-pie-chart-inner"},[_c('e-chart',{ref:"chart"})],1)]),_vm._v(" "),_c('div',{staticClass:"report-pie-chart-title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16008f60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportChart/ReportPieChart.vue
// module id = null
// module chunks = 